/**
@ngdoc directive
@name xmsNotification

@description
There are multiple ways now to add the notifications:<br/>
1. With html code:<br/>
<code>
    &lt;div xms-notification="notificationId" type="success"&gt;
        This is message!
    &lt;/div&gt;
</code>
2. With expression ie. ng-click="xmsNotifications.add(id, type, htmlBody, timeout, onClose, closeLink)"<br/>
ng-click="xmsNotifications.addObj({id: id, type: type, bodyHtml: bodyHtml, closeLink: closeLink, onClose: onClose, timeout: timeout});"<br/>
example:<br/>
&lt;a href="javascript:void(0);" ng-click="xmsNotifications.add('uniqueId', 'success', '<strong>strong</strong> and dynamic!');"<br/>
(xmsNotifications has been registered in the main scope - usually you will want to inject xmsNotificationFactory into your component and
assign to scope/$scope ie. $scope.xmsNotifications = xmsNotificationFactory;)<br/>
<br/>
it probably better to use addObj:<br/>
xmsNotifications.addObj({id: id, type: type, bodyHtml: bodyHtml, closeLink: closeLink, onClose: onClose, timeout: timeout});<br/>
<br/>
3. from the directive/controller with xmsNotificationFactory<br/>
xmsNotifications.add('uniqueId', 'success', '<strong>strong</strong> and dynamic!');<br/>
xmsNotifications.addObj({id: id, type: type, bodyHtml: bodyHtml, closeLink: closeLink, onClose: onClose, timeout: timeout});<br/>
<br/>
4 bulk messages (implemented for file upload)<br/>
xmsNotificationFactory.bulk({'file1':'TestMessage', 'file2':'TestMessage2'});<br/>

@param {string} id set on xms-notification - required unique id!
@param {html} bodyHtml html notification content
@param {selection} type default (by default) / info / warning / danger / success (as Bootstrap)
@param {expression=} onClose callback
@param {boolean=} closeLink (true by default) - whether there is a close (x) link or not
@param {number=} timeout  : close notification after number of seconds (if not specified or 0 the notification persists)

*/
(function() {

    var xmsNotification = function(xmsNotificationFactory){
        return {
            restrict: "EA",
            compile: function( tElement, tAttributes ) {
                // store the content of the directive in the variable then remove it
                var bodyHtml = tElement.html();
                tElement.html(''); // remove

                return function postLink(scope, element, attrs) {
                    if( !angular.isDefined(attrs.xmsNotification) ){
                        throw "Please specify xmsNotification attribute (unique name/id) for the notification!";
                    }
                    xmsNotificationFactory.add(attrs.xmsNotification, attrs.type, bodyHtml, attrs.timeout, attrs.onClose, attrs.closeLink, attrs.useRaw);
                    element.removeAttr('data-angular-compile');
                    // element.remove(); // once data passed we can remove the element(?)
                }
            }
        }
    }
    xmsNotification.$inject = ['xmsNotificationFactory'];
    angular.module('app').directive('xmsNotification', xmsNotification);



    var notificationsBox = function($timeout, xmsNotificationFactory){
        return {
            restrict: "EA",
            scope: true,
            template: [
                '<ul class="notifications-box">',
                '<li xms-notification-render="notification"',
                ' ng-repeat="notification in xmsNotifications.getAll() | orderBy:\'+\':true "',
                ' class="slide-and-fade notification-wrap clearfix"',
                '></li>',
                '</ul>'].join(""),
            replace: true,
            link: function(scope, element, attrs){
                element.addClass('notifications-box');
                scope.xmsNotifications = xmsNotificationFactory;
            }
        }
    }
    notificationsBox.$inject = ['$timeout', 'xmsNotificationFactory'];
    angular.module('app').directive('notificationsBox', notificationsBox);



    var xmsNotificationRender = function($timeout, $sce, xmsNotificationFactory) {
        return {
            restrict: "A",
            scope: true,
            bindToController: {
                notification: '=xmsNotificationRender',
            },
            controller: function(){
                this.$onInit = function(){
                    this.notification.bodyHtml     = $sce.trustAsHtml(this.notification.bodyHtml);
                }
            },
            controllerAs: "ctrl",
            replace: false,
            template: [
                '<div ng-class="{\'has-close\': ctrl.notification.hasCloseLink}"',
                ' class="notification alert-{{ctrl.notification.type}} clearfix" role="alert" aria-live="assertive">',
                '<a href="javascript:void(0);" class="close" title="Close" aria-label="Close" role="button"',
                ' ng-click="closeNotification()">',
                '<i aria-hidden="true">&times;</i>',
                '</a>',
                // Beware of XSS Vulnerability
                '<div ng-if="ctrl.notification.useRaw" class="notification-content" bind-html-compile="ctrl.notification.bodyHtml"></div>',
                '<div ng-if="!ctrl.notification.useRaw" class="notification-content">{{ctrl.notification.bodyHtml}}</div>',
                '</div>'].join(""),
            require: 'xmsNotificationRender',
            link: function(scope, element, attrs, ctrl, transclude) {

                if(ctrl.notification.timeout){
                    $timeout(function(){
                        scope.closeNotification();
                    }, ctrl.notification.timeout*1000);
                }

                scope.closeNotification = function() {
                    if(angular.isDefined(ctrl.notification.onClose)) {
                        eval(ctrl.notification.onClose); //any javascript/jQuery callback
                    }
                    xmsNotificationFactory.remove(ctrl.notification.id);
                }

            }
        };
    }
    xmsNotificationRender.$inject = ['$timeout', '$sce', 'xmsNotificationFactory'];
    angular.module('app').directive('xmsNotificationRender', xmsNotificationRender);

}());


(function() {
    'use strict';

    var xmsNotificationFactory = function($sce) {

        var _notifications = [];

        function normalize(notification){
            notification.type         = notification.type || 'default';
            notification.hasCloseLink = notification.closeLink == "false" ? false : true;
            notification.timeout      = notification.timeout || 0;
            notification.useRaw       = notification.useRaw === "true";

            return notification;
        }

        function findIndex(idYourAreLookingFor){
            return _notifications.map( function(x){ return x.id; } ).indexOf(idYourAreLookingFor);
        }

        return {

            add: function(id, type, bodyHtml, timeout, onClose, closeLink, useRaw) {
                _notifications.push( normalize({id: id, type: type, bodyHtml: bodyHtml, timeout: timeout, closeLink: closeLink, onClose: onClose, useRaw: useRaw}) );
            },

            setAll: function(obj){
                _notifications = obj;
                angular.forEach(notifications, function(obj, id){
                    // TODO: test it
                    obj.id = id;
                    obj = normalize(obj);
                });
            },

            addObj: function(notification) {
                _notifications.push( normalize(notification) );
            },

            get: function(id) {
                var index = findIndex(id);
                return _notifications[index];
            },

            getAll: function() {
                return _notifications;
            },

            remove: function(id) {
                var index = findIndex(id);
                _notifications.splice(index, 1);
            },

            removeAll: function() {
                _notifications = [];
            },

            bulk: function(list, type) { // this is mainly for invalid files
                type = angular.isDefined(type) ? type : 'danger';

                var notifications;
                angular.forEach(list, function(msg, id){
                    _notifications.push(normalize({id:id, type:type, bodyHtml:msg}) );
                });
            }
        }
    }
    xmsNotificationFactory.$inject = ['$sce'];
    angular.module('app').factory('xmsNotificationFactory', xmsNotificationFactory);

}());
